<template>

  <div>
    <v-select
      :multiple="multiple"
      :value="selected"
      @input="change"
      :options="options"
      :placeholder="placeholder">
      </v-select>
  </div>

</template>

<script>
export default {
  name: 'SelectSource',
  props: {
    value: {
      type: [String, Array]
    },
    placeholder: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    options () {
      return this.resources.country.map((val) => {
        return {
          label: val.name,
          value: val.key
        }
      })
    },
    selected () {
      if (this.multiple) {
        return this.options.filter((item) => {
          return Array.isArray(this.value) && this.value.includes(item.value)
        })
      } else {
        return this.options.find((item) => {
          return item.value === this.value
        })
      }
    }
  },
  created () {
  },
  methods: {
    change (val) {
      if (this.multiple) {
        const values = val.map(item => item.value)
        this.$emit('input', values)
      } else {
        const value = val ? val.value : null
        if (this.value !== value) {
          this.$emit('input', value)
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectCountry.vue